import * as React from 'react';
import { historyEvent, URLX, useDynamicData } from '@avensia/excite';
import { authRequired } from '@avensia/excite/client/api';
import { useFlyout } from 'webapp/shell/flyout-context';

export function useAuthModal() {
  const { open } = useFlyout('Login');

  const [startPageUrl] = useDynamicData<NordicNest.Api.WellknownPagesApiModel, string | undefined>({
    selector(data) {
      return data?.startPageUrl;
    },
  });

  const [myPagesStartPageUrl] = useDynamicData<NordicNest.Api.WellknownPagesApiModel, string | undefined>({
    selector(data) {
      return data?.myPagesStartPageUrl;
    },
  });

  const previousUrlRef = React.useRef<string>(undefined);

  React.useEffect(() => {
    historyEvent.on(data => {
      previousUrlRef.current = new URLX(data.previousState.url).search;
    });
  }, []);

  React.useEffect(() => {
    const unsubscribe = authRequired.on(() => {
      open();
    });

    return unsubscribe;
  }, [myPagesStartPageUrl, open, startPageUrl]);
}
